import React from 'react'
import { useTranslation } from 'react-i18next'
import { SystemContainerSidebarTable } from './SystemContainerSidebarTable'
import { ResultCategory } from '../../../provider/result-categories'
import { getFilteredResultsFromContainers } from '../../../calculators/calculator-result-utility'
import { SystemContainerCalculator } from '../../../calculators/SystemContainerCalculator'
import { VersionComparisonSelect } from '../../version-comparison/VersionComparisonSelect'
import { EnergyBusCalculator } from '../../../calculators/EnergyBusCalculator'

type Props = {
  containers: SystemContainerCalculator[]
  comparisonContainers?: SystemContainerCalculator[]
  energyBus?: EnergyBusCalculator
  comparisonEnergyBus?: EnergyBusCalculator
  resultCategories: ResultCategory[]
}

export function SystemContainerSidebarContent({
  containers,
  comparisonContainers,
  energyBus,
  comparisonEnergyBus,
  resultCategories,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      {resultCategories.map((category) => (
        <SystemContainerSidebarTable
          key={category.nameKey}
          header={t(category.nameKey)}
          rowData={category.subCategories.map((subCategory) => ({
            title: t(subCategory.nameKey),
            result: getFilteredResultsFromContainers(
              subCategory,
              containers,
              energyBus,
            ),
            comparisonResult: comparisonContainers
              ? getFilteredResultsFromContainers(
                  subCategory,
                  comparisonContainers,
                  comparisonEnergyBus,
                )
              : undefined,
          }))}
          isComparisonVisible={comparisonContainers !== undefined}
        />
      ))}

      <VersionComparisonSelect />
    </>
  )
}
